import { render, staticRenderFns } from "./buttonMessage.vue?vue&type=template&id=16639887&scoped=true"
import script from "./buttonMessage.vue?vue&type=script&lang=js"
export * from "./buttonMessage.vue?vue&type=script&lang=js"
import style0 from "./buttonMessage.vue?vue&type=style&index=0&id=16639887&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16639887",
  null
  
)

export default component.exports